import { render, staticRenderFns } from "./th-tertiary.vue?vue&type=template&id=17df1332&scoped=true&"
import script from "./th-tertiary.vue?vue&type=script&lang=js&"
export * from "./th-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17df1332",
  null
  
)

export default component.exports